import { styled } from 'styled-components';

import { mq, rowBothMiddle } from '@/shared/ui/styled';

export const Wrapper = styled.div`
    padding: 24px 24px 24px 34px;
    display: flex;
    gap: 22px;
    ${mq.lt.md} {
        padding: 16px 12px;
    }

    .imgBlock {
        ${rowBothMiddle};
        width: 144px;
        height: 111px;
        position: relative;

        & img {
            min-width: initial !important;
            width: initial !important;
            margin: 0 auto;
        }
    }

    .dataInfo {
        display: flex;
        justify-content: space-between;
        flex: 1;
        ${mq.lt.md} {
            flex-direction: column;
        }
    }
`;

export const ImgContainer = styled('div')`
    cursor: pointer;
`;

export const MonthPriceWrapper = styled.div`
    margin: 24px 0 0;
    ${mq.lt.md} {
        margin: 24px 0 16px;
    }
`;

export const Line = styled.p<{ small?: boolean }>`
    font-size: 14px;
    font-weight: 500;
    ${({ small }) =>
        small &&
        `font-size: 12px;
  font-weight: 400;`}
`;
